<template>
<div class="card mb-4">
    <div class="card-header">Email</div>
    <div class="card-body">

        <div class="alert alert-dismissible fade show alert-success"
             role="alert"
             v-if="updated">
            Your email has been updated.
            <button type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div :class="`alert alert-danger`"
             role="alert"
             v-for="(error, index) in validationErrors">
            {{ error }}
        </div>

        <form v-on:submit.prevent="onSubmit">
            <div class="row">
                <div class="col-md-3">
                    <label for="email-address-input">New Email</label>
                </div>
                <div class="col-md-9">
                    <input type="text"
                           class="form-control mb-2 mr-md-2"
                           id="email-address-input"
                           placeholder="Enter your new email address"
                           autocomplete="off"
                           v-model="email">
                </div>

                <div class="col-md-3">
                    <label for="confirm-email-address-input">Confirm Email</label>
                </div>
                <div class="col-md-9">
                    <input type="text"
                           class="form-control mb-2 mr-md-2"
                           id="confirm-email-address-input"
                           placeholder="Confirm your new email address"
                           autocomplete="off"
                           v-model="email_confirmation">
                </div>

                <div class="col-md-3">
                    <label for="email-password-input">Password</label>
                </div>
                <div class="col-md-9">
                    <input type="password"
                           class="form-control mb-2 mr-md-2"
                           id="email-password-input"
                           placeholder="Enter your current password"
                           autocomplete="new-password"
                           v-model="password">
                </div>
                <div class="col-md-12 mt-2">
                    <button type="submit" class="btn btn-primary float-right">Save</button>
                </div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    export default {
        name: "EmailAddressUpdatePanel",

        data() {
            return {
                updated: false,
                email: "",
                email_confirmation: "",
                password: "",
                validationErrors: [],
            };
        },

        methods: {
            onSubmit(e) {
                this.updated = false;
                axios.put('/account/email', {
                    email: this.email,
                    email_confirmation: this.email_confirmation,
                    password: this.password
                })
                    .then(response => {
                        this.email = "";
                        this.email_confirmation = "";
                        this.password = "";
                        this.validationErrors = [];
                        this.updated = true;
                    })
                    .catch((err, x, y) => {
                        const errors = err.response.data.errors;
                        this.validationErrors = [].concat(
                            errors.email || [],
                            errors.password || []
                        );
                        this.password = "";
                    });
            }
        }
    }
</script>

<style scoped>

</style>
